import React from "react";
import {connect} from "react-redux";
import {Button, Col, Form, Input, message, Modal, Row, Select, Space, Tooltip} from "antd";
import {displayErrors} from "../../libs/utils";
import {getSoftwarelist, migrateSoftware, testFTPConnection} from "../../actions/domains";
import {FolderViewOutlined} from "@ant-design/icons";
import SoftwareMigrationFTPPathModal from "./SoftwareMigrationFTPPathModal";

class SoftwareMigrationModal extends React.Component {
    state = {
        protocol: 'https://',
        remote_domain: this.props.domainName,
        install_directory: '',
        software: '',

        ftp_username: '',
        ftp_password: '',
        ftp_port: 21,
        ftp_host: '',
        ftp_path: '',
        ftp_mode: 'PASSIVE',
        ftp_security: 'NONE',

        loadingScripts: true,
        scriptsLoaded: false,
        scripts: [],

        migrating: false,
        showFolderPickerModal: false,

        ftpConnectionTesting: false,
        ftpConnectionTested: false,
        ftpConnectionSuccessful: false,
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.showModal && this.state.loadingScripts && this.state.scripts.length === 0) {
            this.props.getSoftwarelist(this.props.domain, (res) => {
                this.setState({ loadingScripts: false, scripts: res.data })
            }, (err) => {
                if(typeof err.response !== 'undefined') {
                    displayErrors(err.response.data);
                    this.setState({ loadingScripts: false })
                }
            });
        }
    }

    migrateSoftware() {
        this.setState({ migrating: true });

        let data = {
            protocol: this.state.protocol,
            remote_domain: this.state.remote_domain,
            install_directory: this.state.install_directory,
            software: this.state.software,

            ftp_username: this.state.ftp_username,
            ftp_password: this.state.ftp_password,
            ftp_port: this.state.ftp_port,
            ftp_host: this.state.ftp_host,
            ftp_path: this.state.ftp_path
        }

        this.props.migrateSoftware(this.props.domain, data, () => {
            this.setState({ migrating: false });

            message.success('Software migration task created!');

            this.props.closeModal();
            this.props.loadOverview();
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
                this.setState({ migrating: false })
            }
        });
    }

    closeModal() {
        this.setState({
            protocol: 'https://',
            remote_domain: this.props.domainName,
            install_directory: '',
            software: '',

            ftp_username: '',
            ftp_password: '',
            ftp_port: 21,
            ftp_host: '',
            ftp_path: '',
            ftp_mode: 'PASSIVE',
            ftp_security: 'NONE',

            loadingScripts: true,
            scriptsLoaded: false,
            scripts: [],

            migrating: false,
            showFolderPickerModal: false,

            ftpConnectionTesting: false,
            ftpConnectionTested: false,
            ftpConnectionSuccessful: false,
        });

        this.props.closeModal();
    }

    testConnection() {
        if(this.state.ftp_host.length === 0 || this.state.ftp_port.length === 0 || this.state.ftp_username.length === 0 || this.state.ftp_password.length === 0) {
            return message.error('Please fill in all FTP details!');
        }

        let data = {
            ftp_username: this.state.ftp_username,
            ftp_password: this.state.ftp_password,
            ftp_port: this.state.ftp_port,
            ftp_host: this.state.ftp_host,
            ftp_mode: this.state.ftp_mode,
            ftp_security: this.state.ftp_security,
        }

        this.setState({ ftpConnectionTesting: true });

        this.props.testFTPConnection(this.props.domain, data, () => {
            this.setState({ ftpConnectionTesting: false, ftpConnectionSuccessful: true, ftpConnectionTested: true });
            message.success('FTP connection successful!');
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
                this.setState({ ftpConnectionTesting: false, ftpConnectionSuccessful: false, ftpConnectionTested: false  })
            }
        });
    }

    render() {
        const { Option } = Select;

        let ftpDir = <Button size='small' disabled={true} icon={<FolderViewOutlined />}>Browse</Button>;

        if(this.state.ftpConnectionTested && this.state.ftpConnectionSuccessful) {
            ftpDir = <Tooltip placement='left' title='Find from remote server'>
                <Button size='small' icon={<FolderViewOutlined />} onClick={() => this.setState({ showFolderPickerModal: true })}>Browse</Button>
            </Tooltip>;
        }

        return <>
            <Modal
                centered
                title='Migrate Software'
                open={this.props.showModal}
                onCancel={() => this.closeModal()}
                footer={<Space>
                    <Button onClick={() => this.props.closeModal()}>Close</Button>
                    {this.state.ftpConnectionTested ? <Button type='primary' disabled={this.state.migrating} loading={this.state.migrating}
                                                              onClick={() => this.migrateSoftware()}>Migrate</Button> : <Button type='primary' disabled={this.state.ftpConnectionTesting} loading={this.state.migrating}
                                                                                                                                onClick={() => this.testConnection()}>Test Connection</Button>}
                </Space>}
                destroyOnClose={true}>

                <Form layout='vertical'>
                    <Row gutter={[16, 16]}>
                        <Col xs={24} md={12}>
                            <Form.Item label='Software'>
                                <Select showSearch placeholder='Select software'
                                        loading={this.state.loadingScripts}
                                        disabled={this.state.loadingScripts}
                                        onChange={(value) => this.setState({ software: value })}>
                                    {this.state.scripts.map((script) => {
                                        return <Option key={script.id} value={script.key}>{script.name}</Option>
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item label='Protocol'>
                                <Select showSearch placeholder='Select protocol' value={this.state.protocol} onChange={(value) => this.setState({ protocol: value })}>
                                    <Option value='http://'>http://</Option>
                                    <Option value='https://'>https://</Option>
                                    <Option value='http://www'>http://www</Option>
                                    <Option value='https://www'>https://www</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <Form.Item label='Remote domain' extra={<small><em>The domain where your script is installed</em></small>}>
                                <Input value={this.state.remote_domain}
                                       onChange={(e) => this.setState({ remote_domain: e.target.value })} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <Form.Item label='FTP path' extra={<small><em>Where the installation exists in the remote server</em></small>}>
                                <Input value={this.state.ftp_path} placeholder='/public_html/mydomain.tld'
                                       onChange={(e) => this.setState({ ftp_path: e.target.value })}
                                       suffix={ftpDir} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]}>
                        <Col xs={24} md={12}>
                            <Form.Item label='FTP username'>
                                <Input value={this.state.ftp_username}
                                       onChange={(e) => this.setState({ ftp_username: e.target.value })} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item label='FTP password'>
                                <Input value={this.state.ftp_password}
                                       onChange={(e) => this.setState({ ftp_password: e.target.value })} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]}>
                        <Col xs={24} md={12}>
                            <Form.Item label='FTP host'>
                                <Input value={this.state.ftp_host}
                                       onChange={(e) => this.setState({ ftp_host: e.target.value })} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item label='FTP port'>
                                <Input value={this.state.ftp_port}
                                       onChange={(e) => this.setState({ ftp_port: e.target.value })} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]}>
                        <Col xs={24} md={12}>
                            <Form.Item label='FTP mode'>
                                <Select value={this.state.ftp_mode} onChange={(value) => this.setState({ ftp_mode: value })}>
                                    <Option value='PASSIVE'>Passive</Option>
                                    <Option value='ACTIVE'>Active</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item label='FTP security'>
                                <Select value={this.state.ftp_security} onChange={(value) => this.setState({ ftp_security: value })}>
                                    <Option value='NONE'>None (plain FTP)</Option>
                                    <Option value='TLS'>TLS</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <Form.Item label='Install directory' extra={<small><em>Leave blank for root directory</em></small>}>
                                <Input value={this.state.install_directory}
                                       onChange={(e) => this.setState({ install_directory: e.target.value })}/>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>

            <SoftwareMigrationFTPPathModal
                showModal={this.state.showFolderPickerModal}
                domain={this.props.domain}
                host={this.state.ftp_host}
                username={this.state.ftp_username}
                password={this.state.ftp_password}
                port={this.state.ftp_port}
                mode={this.state.ftp_mode}
                security={this.state.ftp_security}
                closeModal={() => this.setState({ showFolderPickerModal: false })}
                updateFTPPath={(path) => this.setState({ ftp_path: path })}
            />
        </>;
    }
}

const mapStateToProps = state => ({
    user: state.auth.user
});

export default connect(mapStateToProps, { getSoftwarelist, migrateSoftware, testFTPConnection })(SoftwareMigrationModal);